module.exports = __webpack_public_path__ + "media/eyejack-webar-brand-comp.e87e4670.mp4";